// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xr69m","contentWrapper":"styles_contentWrapper__wmME5","text":"styles_text__mvrOt"};